import { ref } from 'vue';
import Swal from 'sweetalert2';
let disconnectCount = 0;
let websocketInstance: WebSocket | null = null;
let computer_agent_uuid = ref('');
let reconnectTimeout: ReturnType<typeof setTimeout> | null = null;
let nextReconnectAttemptAt = 0;
const MAX_RECONNECT_ATTEMPTS = 5;
const NEXT_ATTEMPT_WAIT_MS = 25000;
const LOGOUT_FALLBACK_PATH = '/logoutProva';

function resolveLogoutUrl(logoutUrl?: string) {
    if (typeof logoutUrl !== 'string') {
        return LOGOUT_FALLBACK_PATH;
    }

    const normalized = logoutUrl.trim();
    if (!normalized || normalized.includes('undefined')) {
        return LOGOUT_FALLBACK_PATH;
    }

    return normalized;
}

function redirectToLogout(logoutUrl?: string) {
    window.location.href = resolveLogoutUrl(logoutUrl);
}

export function checkComputerUUID(new_computer_uid: string, logout_url: string, descricao_computer: string, is_ws_verification: boolean, is_agent_support_ws_verification: boolean) {
    if (is_ws_verification && is_agent_support_ws_verification) {
        if (computer_agent_uuid.value !== new_computer_uid) {
            console.warn('UUID inválido detectado');
            //@ts-ignore
            Swal.fire({
                title: 'Atenção!',
                text: `Este não é o computador correto para realizar a prova. Por favor, utilize o computador identificado como: ${descricao_computer}. A sessão será encerrada em 20 segundos.`,
                icon: 'warning',
                timer: 20000,
                timerProgressBar: true,
                showConfirmButton: false,
                allowOutsideClick: false,
                didClose: () => {
                    redirectToLogout(logout_url);
                }
            });
        }
    }
}

export function checkConnection(props, connectionStatus, connectionSpinner) {
    if (!props.is_ws_verification || !props.is_agent_support_ws_verification) {
        connectionStatus.value.connection = true;
        connectionStatus.value.verified = true;
        connectionSpinner.value = false;
        return;
    }

    if (!websocketInstance) {
        if (nextReconnectAttemptAt > Date.now()) {
            return;
        }

        const websocketURL = `ws://localhost:5901/localuuid`;
        websocketInstance = new WebSocket(websocketURL);

        websocketInstance.onopen = () => {
            console.log(`Websocket conectado - URL: ${websocketURL}`);
            connectionStatus.value.connection = true;
            connectionSpinner.value = false;
            nextReconnectAttemptAt = 0;
            if (reconnectTimeout) {
                clearTimeout(reconnectTimeout);
                reconnectTimeout = null;
            }

            if (disconnectCount > 0) {
                disconnectCount = 0;
                //@ts-ignore
                Swal.fire({
                    title: 'Servidor reconectado com sucesso.',
                    icon: 'success',
                    position: "top-end",
                    timer: 2000,
                    timerProgressBar: true,
                    showConfirmButton: false,
                    allowOutsideClick: false,
                });
            }
        };

        websocketInstance.onmessage = (event) => {
            try {
                const agentUUID = event.data.replace(/"/g, "").trim();
                computer_agent_uuid.value = agentUUID;
                if (agentUUID && agentUUID === props.computer_uid) {
                    connectionStatus.value.verified = true;
                } else {
                    connectionStatus.value.verified = false;
                    console.warn('UUID inválido detectado:', agentUUID);
                    //@ts-ignore
                    Swal.fire({
                        title: 'Atenção!',
                        text: `Este não é o computador correto para realizar a prova. Por favor, utilize o computador identificado como: ${props.descricao_computer}. A sessão será encerrada em 20 segundos.`,
                        icon: 'warning',
                        timer: 20000,
                        timerProgressBar: true,
                        showConfirmButton: false,
                        allowOutsideClick: false,
                        didClose: () => {
                            redirectToLogout(props.logout_url);
                        }
                    });
                }
            } catch (error) {
                console.warn("Erro ao processar mensagem WebSocket:", error);
                connectionStatus.value.verified = false;
                //@ts-ignore
                Swal.fire({
                    title: 'Atenção!',
                    text: `Ocorreu um erro ao processar a verificação do computador. A sessão será encerrada em 20 segundos.`,
                    icon: 'warning',
                    timer: 20000,
                    timerProgressBar: true,
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    didClose: () => {
                        redirectToLogout(props.logout_url);
                    }
                });
            }
        };

        websocketInstance.onclose = (event) => {
            console.log('Conexão fechada - Código de Status:', event.code);
            websocketInstance = null;
            connectionStatus.value.connection = false;
            connectionStatus.value.verified = false;
            connectionSpinner.value = false;

            switch (event.code) {
                case 404:
                    connectionStatus.value.connection = true;
                    break;
                case 1006:
                    if (disconnectCount < MAX_RECONNECT_ATTEMPTS) {
                        disconnectCount++;
                        nextReconnectAttemptAt = Date.now() + NEXT_ATTEMPT_WAIT_MS;

                        if (reconnectTimeout) {
                            clearTimeout(reconnectTimeout);
                            reconnectTimeout = null;
                        }

                        reconnectTimeout = setTimeout(() => {
                            reconnectTimeout = null;
                            checkConnection(props, connectionStatus, connectionSpinner);
                        }, NEXT_ATTEMPT_WAIT_MS);

                        //@ts-ignore
                        Swal.fire({
                            title: `Agente desconectado. Reinicie o Agente e tente novamente. Tentativa: ${disconnectCount}`,
                            icon: 'error',
                            position: "top-end",
                            timer: 3000,
                            timerProgressBar: true,
                            showConfirmButton: false,
                            allowOutsideClick: false,
                            didClose: () => {
                                //@ts-ignore
                                Swal.fire({
                                    title: 'Esperando para tentar mais uma vez...',
                                    text: `Nova tentativa automática em ${NEXT_ATTEMPT_WAIT_MS / 1000} segundos.`,
                                    icon: 'info',
                                    position: "top-end",
                                    timer: NEXT_ATTEMPT_WAIT_MS,
                                    timerProgressBar: true,
                                    showConfirmButton: false,
                                    allowOutsideClick: false,
                                });
                            }
                        });
                    } else {
                        //@ts-ignore
                        Swal.fire({
                            title: 'Número máximo de tentativas de reconexão atingido',
                            text: 'Deslogando em 3 segundos...',
                            icon: 'error',
                            position: "top-end",
                            timer: 3000,
                            timerProgressBar: true,
                            showConfirmButton: false,
                            allowOutsideClick: false,
                            didClose: () => {
                                redirectToLogout(props.logout_url);
                            }
                        });
                    }
                    break;
                default:
                    nextReconnectAttemptAt = 0;
                    break;
            }
        };
    } else {
        connectionStatus.value.connection = true;
        connectionStatus.value.verified = true;
        connectionSpinner.value = false;
    }
}
